<script setup lang="ts">
const { body, variant = 'full-width' } = defineProps<{
  body: string
  variant?: 'full-width' | 'prose'
}>()
</script>

<template>
  <ContentBlockViewPartialContainer>
    <MarkdownRenderer
      v-if="body"
      :content="body"
      :max-width="variant == 'full-width' ? 'none' : 'prose'"
      :class="variant == 'full-width' ? 'w-full pr-4 sm:pr-8 md:pr-12' : ''"
    />
    <span v-else />
  </ContentBlockViewPartialContainer>
</template>
